import { makeStyles } from "@material-ui/core/styles";
import { Wrapper } from "../base/Wrapper";
import TitleBar from "../TitleBar";
import { Avatar, CircularProgress } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Fab from "@material-ui/core/Fab";
import { MdSave } from "react-icons/md";
import { navigate } from "@reach/router";
import { getCurrentUserInfo } from "../../auth/getCurrentUserInfo";
import { updateCurrentUserInfo } from "../../auth/updateCurrentUserInfo";
import { useEffect, useState } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { storage } from "../../index";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    marginTop: theme.spacing(5),
    width: theme.spacing(20),
    height: theme.spacing(20),
    margin: "0 auto",
  },
  upload: {
    marginTop: theme.spacing(2),
    margin: "0 auto",
  },
  textfield: {
    width: "80%",
    marginBottom: theme.spacing(1),
  },
  button: {
    position: "fixed",
    bottom: 70,
    right: theme.spacing(1),
    zIndex: 2,
  },
  icon: {
    fontSize: "1.5rem",
  },
  wrapper: {
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
}));

export default function ProfileSettings() {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true);
  const [userName, setUserName] = useState("");
  const [height, setHeight] = useState();
  const [weight, setWeight] = useState();
  const [photoUrl, setPhotoUrl] = useState("");
  const [progress, setProgress] = useState(0);
  const [userNameForSearch, setUserNameForSearch] = useState("");

  useEffect(() => {
    const loadUserInfo = async () => {
      const userInfo = await getCurrentUserInfo();
      if (userInfo) {
        setUserName(userInfo.userName || "");
        setWeight(userInfo.weight || "");
        setHeight(userInfo.height || "");
        setPhotoUrl(userInfo.photoUrl || "");
        setUserNameForSearch(userInfo.userNameForSearch || "");
        setIsLoading(false);
      }
    };

    loadUserInfo();
  }, []);

  const onSubmitChanges = async () => {
    let changes = {
      userName,
      photoUrl,
      ...(height && { height }),
      ...(weight && { weight }),
      userNameForSearch,
    };

    await updateCurrentUserInfo(photoUrl ? { ...changes, photoUrl } : changes);
  };

  const handleUpload = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      setPhotoUrl(image);
      const uploadTask = storage.ref(`profileImages/${image.name}`).put(image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          setProgress(progress);
        },
        (error) => {
          console.error("uplaod failed", error);
        },
        () => {
          storage
            .ref("profileImages")
            .child(image.name)
            .getDownloadURL()
            .then((imageUrl) => {
              setPhotoUrl(imageUrl);
            });
        }
      );
    }
  };

  return (
    <div>
      <TitleBar title="Profil bearbeiten" navigateTo="/profile" colorPrimary />
      <Wrapper>
        <div className={classes.root}>
          {isLoading ? (
            <Skeleton variant="circle" className={classes.avatar} />
          ) : (
            <Avatar
              className={classes.avatar}
              alt="Profilbild"
              src={photoUrl}
              referrerPolicy="no-referrer"
            />
          )}
          <div className={classes.wrapper}>
            <Button
              component="label"
              onChange={handleUpload}
              color="primary"
              disabled={progress < 100 && progress > 0}
              className={classes.upload}
            >
              Bild ändern
              <input type="file" style={{ display: "none" }} accept="image/*" />
            </Button>
            {progress < 100 && progress > 0 && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
          {isLoading ? (
            <>
              <Skeleton variant="rect" className={classes.textfield} height={48} animation="wave" />
            </>
          ) : (
            <>
              <TextField
                className={classes.textfield}
                label="Nutzername"
                defaultValue={userName}
                onChange={(e) => {
                  setUserName(e.target.value);
                  setUserNameForSearch(e.target.value.toLowerCase());
                }}
              />
              <TextField
                className={classes.textfield}
                label="Größe in cm"
                defaultValue={height}
                error={height && height <= 100}
                helperText={height && height <= 100 ? "Überprüfe bitte deine Eingabe" : null}
                type="number"
                onChange={(e) => setHeight(+e.target.value)}
              />

              <TextField
                className={classes.textfield}
                label="Gewicht in kg"
                defaultValue={weight}
                error={weight && weight <= 20}
                helperText={weight && weight <= 20 ? "Überprüfe bitte deine Eingabe" : null}
                type="number"
                onChange={(e) => setWeight(+e.target.value)}
              />
            </>
          )}
          <Fab
            className={classes.button}
            aria-label="Speichern"
            color="primary"
            disabled={progress < 100 && progress > 0}
            onClick={() => {
              onSubmitChanges();
              navigate("./profile");
            }}
          >
            <MdSave className={classes.icon} />
          </Fab>
        </div>
      </Wrapper>
    </div>
  );
}
